<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <ifc-account-case-name-input
      [productCode]="data.query.productCode"
      baseFilterItem
      [excludedProductCode]="data.query.excludedProductCode"
      [entityId]="data.query.entityId"
      [fc]="form.get('description')"
    ></ifc-account-case-name-input>
    <ifc-account-case-number-input
      [productCode]="data.query.productCode"
      baseFilterItem
      [excludedProductCode]="data.query.excludedProductCode"
      [entityId]="data.query.entityId"
      *ngIf="data.productCode === productCodes.Law"
      [fc]="form.get('externalId')"
    ></ifc-account-case-number-input>
    <ifc-account-loan-number-input
      [productCode]="data.query.productCode"
      baseFilterItem
      [excludedProductCode]="data.query.excludedProductCode"
      [entityId]="data.query.entityId"
      [fc]="form.get('loanNumber')"
    ></ifc-account-loan-number-input>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select formControlName="customerStatus" placeholder="All">
        <mat-option>All</mat-option>
        <mat-option *ngFor="let option of statusOptions" [value]="option.value">
          {{ option.name | startCase }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ifc-filter-param-date-range-input
      [fc]="form.get('createdOn')"
      baseFilterItem
      [label]="'Created on'"
      (rangeSelected)="createdDateSelected($event)"
    ></ifc-filter-param-date-range-input>

    <ng-container *ngIf="form.get('createdOn')?.value === 'custom'">
      <ifc-datepicker [fc]="form.get('createdOnFrom')" [label]="'Created on from'" baseFilterItem></ifc-datepicker>
      <ifc-datepicker [fc]="form.get('createdOnTo')" [label]="'Created on to'" baseFilterItem></ifc-datepicker>
    </ng-container>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Favorite</mat-label>
      <mat-select formControlName="favorite" placeholder="All">
        <mat-option [value]="null">All</mat-option>
        <mat-option [value]="'true'">Yes</mat-option>
        <mat-option [value]="'false'">No</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" baseFilterItem *ngIf="data.productCode !== productCodes.Law">
      <mat-label>Product type</mat-label>
      <mat-select formControlName="productCode" placeholder="All">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let option of productTypeOptions" [value]="option.value">{{ option.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
